<template>
  <button :disabled="disableButton" type="submit">
    <slot></slot>
  </button>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "UserFormSubmitButton",
  computed: {
    ...mapGetters({
      passwordKnown: "userForm/passwordKnown",
      passwordStrength: "userForm/passwordStrength",
    }),
    disableButton() {
      return this.passwordKnown || this.passwordStrength < 0.5;
    },
  },
};
</script>
